import styled from 'styled-components';

export const TableWrapper = styled.table`
  width: 100%;
  border: 1px solid #f1f3f5;
  border-collapse: collapse;
  table-layout: auto;

  thead {
    background-color: transparent;
  }
`;

export const SectionOptionLabel = styled.span`
  width: 100%;
  display: block;
`;

export const SectionsInfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: #adb5bd;
  cursor: help;
  font-size: 13px;
`;

export const FundNameHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const FundCount = styled.span`
  font-size: 10px;
  font-weight: 400;
  color: #adb5bd;
  text-transform: none;
  letter-spacing: 0;
`;
